import React from 'react';
import { UrgencyBar, Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing, Potenciador } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-brandOrange selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
      <UrgencyBar data-id="element-3" />
      <Hero data-id="element-4" />
      <SocialProof data-id="element-5" />
      <Testimonials1 data-id="element-6" />
      <Problem data-id="element-7" />
      <ProductTomos data-id="element-8" />
      <Bonuses data-id="element-9" />
      <UrgencyCounter data-id="element-10" />
      <Pricing data-id="element-11" />
      <Potenciador data-id="element-12" />
      <Testimonials2 data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <CostOfNotHaving data-id="element-16" />
      <FinalCTA data-id="element-17" />
      <Footer data-id="element-18" />
    </div>;
}